export default
{
    name: 'app-sound-manager',

    props:
    {
        isMuted: { type: Boolean, default: false }
    },

    data()
    {
        return {
            sounds: this.$root.content.sounds.sounds
        }
    },

    watch:
    {
        isMuted: 'onMutedChange'
    },

    created()
    {
        this.eventHub.$on('app-sound-manager:play', this.onPlay)
        this.eventHub.$on('app-sound-manager:pause', this.onPause)
        this.eventHub.$on('app-sound-manager:back-to-start', this.onBackToStart)
        this.eventHub.$on('app-sound-manager:mute', this.onMute)
        this.eventHub.$on('app-sound-manager:unmute', this.onUnmute)

        this.eventHub.$on('application:onEnterFrame', this.onEnterFrame)
    },

    mounted()
    {
        this.$players = this.$el.querySelectorAll('.js-player')

        this.$players.forEach((player, index) =>
        {
            player.volume = this.sounds[index].volume
        })
    },

    destroyed()
    {
        this.eventHub.$off('app-sound-manager:play', this.onPlay)
        this.eventHub.$off('app-sound-manager:pause', this.onPause)
        this.eventHub.$off('app-sound-manager:back-to-start', this.onBackToStart)
        this.eventHub.$off('app-sound-manager:mute', this.onMute)
        this.eventHub.$off('app-sound-manager:unmute', this.onUnmute)

        this.eventHub.$off('application:onEnterFrame', this.onEnterFrame)
    },

    methods:
    {
        onPlay(id)
        {
            this.$players.forEach(player =>
            {
                if (player.getAttribute('data-id') === id)
                {
                    player.play()
                }
            })
        },

        onPause(id)
        {
            this.$players.forEach(player =>
            {
                if (player.getAttribute('data-id') === id)
                {
                    player.pause()
                }
            })
        },

        onBackToStart(id)
        {
            this.$players.forEach(player =>
            {
                if (player.getAttribute('data-id') === id)
                {
                    player.currentTime = 0
                }
            })
        },

        onMute(id)
        {
            this.$players.forEach(player =>
            {
                if (player.getAttribute('data-id') === id)
                {
                    this._isFadingOut = true
                    this._playerToFadeOut = player
                }
            })
        },

        onUnmute(id)
        {
            this.$players.forEach((player, index) =>
            {
                if (player.getAttribute('data-id') === id)
                {
                    this._isFadingIn = true
                    this._playerToFadeIn = player
                    this._playerIndexToFadeIn = index
                }
            })
        },

        onMutedChange()
        {
            this.$players.forEach(player =>
            {
                if (this.isMuted)
                {
                    player.pause()
                }
                else
                {
                    player.play()
                }
            })
        },

        onEnterFrame()
        {
            if (this._isFadingOut)
            {
                if (this._playerToFadeOut.volume > 0.1)
                {
                    this._playerToFadeOut.volume -= 0.01
                }
                else
                {
                    this._playerToFadeOut.volume = 0
                    this._isFadingOut = false
                }
            }

            if (this._isFadingIn)
            {
                if (this._playerToFadeIn.volume < this.sounds[this._playerIndexToFadeIn].volume)
                {
                    this._playerToFadeIn.volume += 0.05
                }
                else
                {
                    this._playerToFadeIn.volume = this.sounds[this._playerIndexToFadeIn].volume
                    this._isFadingIn = false
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-sound-manager/script.js